import { AberrationExtraDetailsComponent } from './components/aberration-extra-details/aberration-extra-details.component';
import { AberrationInfoTabComponent } from './components/aberration-info-tab/aberration-info-tab.component';
import { AberrationNotesTabComponent } from './components/aberration-notes-tab/aberration-notes-tab.component';
import { AberrationsRouteWrapperComponent } from './components/aberrations-route-wrapper/aberrations-route-wrapper.component';
import { AberrationsWrapperUpgradeDirective } from './components/aberrations-wrapper-upgrade/aberrations-wrapper-upgrade.directive';
import { AddTestComponent } from './components/test-actions/add-test/add-test.component';
import { AttachmentComponent } from '@ispm/migration/components/attachments/attachment.component';
import { AttachmentService } from '@ispm/migration/services/attachment.service';
import { CaseSummaryComponent } from '@ispm/test/components/case-summary/case-summary.component';
import { ClinicalTrialsComponent } from '@ispm/migration/components/clinical-trial-migration/clinical-trial.component';
import { CollectionFormComponent } from '@ispm/test/components/collection-form/collection-form.component';
import { DataCollectionTabComponent } from './components/data-collection-tab/data-collection-tab.component';
import { DiagnosticOrderActionsService } from './services/diagnostic-order-actions.service';
import { DocumentPreviewComponent } from '@ispm/test/components/documents-tab/document-preview/document-preview.component';
import { DocumentsActionsComponent } from '@ispm/test/components/documents-tab/documents-actions/documents-actions.component';
import { DocumentsListComponent } from '@ispm/test/components/documents-tab/documents-list/documents-list.component';
import { DocumentsTabComponent } from '@ispm/test/components/documents-tab/documents-tab.component';
import { DocumentsTabService } from './services/documents-tab.service';
import { EditableAnnotationService } from './services/editable-annotation.service';
import { EditableAnnotationsComponent } from './components/editable-annotation/editable-annotations.component';
import { EmrIntegrationService } from '@ispm/test/services/emr-integration.service';
import { EmptyPageComponent } from '@ispm/test/components/empty-page/empty-page.component';
import { FindingInputComponent } from './components/immunotherapy/finding-input/finding-input.component';
import { FindingsActionCreatorService } from './components/immunotherapy/services/findings-action-creator.service';
import { FindingsDifferentCompareComponent } from './components/immunotherapy/findings-different-compare/findings-different-compare.component';
import { IEService } from '@ispm/shared/services/IE.service';
import { ImmunotherapyComponent } from './components/immunotherapy/immunotherapy.component';
import { MolecularFindingService } from './components/immunotherapy/services/molecular-finding.service';
import { NewOrderComponent } from '@ispm/migration/components/new-order/new-order.component';
import { NotesSidePanelComponent } from './components/notes-upgrade/notes-side-panel.component';
import { OrderService } from '@ispm-client/modules/orders/services/order.service';
import { PathwayPreviewService } from '@ispm/test/services/preview/pathway-preview.service';
import { PcrGraphComponent } from './components/pcr-graph/pcr-graph.component';
import { PdfService } from '@ispm/test/services/pdf.service';
import { PollJobService } from '@ispm/test/services/poll-job.service';
import { ProcessingComponent } from './components/processing/processing.component';
import { QcService } from '../../quality-check/services/qc.service';
import { QmsSectionComponent } from './components/qms-section/qms-section.component';
import { ReassignModalService } from '@ispm/layout/services/reassign-modal.service';
import { ReassignTestModalComponent } from '@ispm/layout/components/modals/reassign-test-modal/reassign-test-modal.component';
import { ReportPreviewActionsService } from './services/report-preview-actions.service';
import { ReportSummaryTextComponent } from '@ispm/test/components/documents-tab/report-summary-text/report-summary-text.component';
import { RulerGraphComponent } from './components/ruler-graph/ruler-graph.component';
import { ScrollGlueDirective } from './components/notes-upgrade/scroll-glue-migrated.directive';
import { SignalResultsComponent } from './components/signal-results/signal-results.component';
import { SpecimensAndSamplesService } from '../../specimens-and-samples/services/specimens-and-samples.service';
import { TechnicalInfoComponent } from './components/technical-info/technical-info.component';
import { TestActionsComponent } from './components/test-actions/test-actions.component';
import { TestActionsService } from './services/test-actions.service';
import { TestBarComponent } from './components/test-bar/test-bar.component';
import { TestHeaderElementsComponent } from './components/test-header-elements/test-header-elements.component';
import { TestHeaderElementsService } from './services/test-header-elements.service';
import { TestInfoComponent } from './components/test-info/test-info.component';
import { TestListComponent } from './components/test-actions/test-list/test-list.component';
import { TestListItemComponent } from './components/test-actions/test-list/test-list-item/test-list-item.component';
import { TestMetaActionCreatorService } from './services/test-meta-action-creator.service';
import { TestService } from './services/test.service';
import { TestSummaryActionsService } from './services/test-summary-actions.service';
import { TestSummaryComponent } from './components/test-summary/test-summary.component';
import { TestViewComponent } from './components/test-view/test-view.component';
import { UsersStoreHandler } from './services/users-store-handler';
import { WorklistService } from '../../worklist/services/worklist.service';
import { AllOrdersService } from './services/all-orders.service';
import { WorklistNavigationService } from './services/worklist-navigation.service';

export const testComponents = [
  AberrationExtraDetailsComponent,
  AberrationInfoTabComponent,
  AberrationNotesTabComponent,
  AberrationsRouteWrapperComponent,
  AberrationsWrapperUpgradeDirective,
  AddTestComponent,
  AttachmentComponent,
  CaseSummaryComponent,
  ClinicalTrialsComponent,
  CollectionFormComponent,
  DataCollectionTabComponent,
  DocumentPreviewComponent,
  DocumentsActionsComponent,
  DocumentsListComponent,
  DocumentsTabComponent,
  EditableAnnotationsComponent,
  EmptyPageComponent,
  FindingInputComponent,
  FindingsDifferentCompareComponent,
  ImmunotherapyComponent,
  NewOrderComponent,
  NotesSidePanelComponent,
  PcrGraphComponent,
  ProcessingComponent,
  QmsSectionComponent,
  ReassignTestModalComponent,
  ReportSummaryTextComponent,
  RulerGraphComponent,
  ScrollGlueDirective,
  SignalResultsComponent,
  TechnicalInfoComponent,
  TestActionsComponent,
  TestBarComponent,
  TestHeaderElementsComponent,
  TestInfoComponent,
  TestListComponent,
  TestListItemComponent,
  TestSummaryComponent,
  TestViewComponent,
];

export const testServices = [
  AttachmentService,
  DiagnosticOrderActionsService,
  DocumentsTabService,
  EditableAnnotationService,
  EmrIntegrationService,
  FindingsActionCreatorService,
  IEService,
  MolecularFindingService,
  OrderService,
  PathwayPreviewService,
  PdfService,
  PollJobService,
  QcService,
  ReassignModalService,
  ReportPreviewActionsService,
  SpecimensAndSamplesService,
  TestActionsService,
  TestHeaderElementsService,
  TestMetaActionCreatorService,
  TestService,
  TestSummaryActionsService,
  UsersStoreHandler,
  WorklistService,
  AllOrdersService,
  WorklistNavigationService
];
